import useComparativeStudies from '../../App/hooks/useComparativeStudies';
import { useAppDispatch } from '../../App/redux/store';
import ActionModal from '../../features/modals/components/actionModal/ActionModal';
import { modalsActions } from '../../features/modals/modalsSlice';
import { comparativeStudiesActions } from '../../store/comparativeStudies/actions';

import './comparativeStudyDeleteModal.scss';

const ComparativeStudyDeleteModal = () => {
  const { deleteModal } = useComparativeStudies();

  const dispatch = useAppDispatch();

  const handleClose = () => {
    dispatch(modalsActions.deleteComparativeStudy(null));
  };

  return (
    <ActionModal
      closeAction={handleClose}
      validAction={comparativeStudiesActions.deleteComparativeStudy.request(
        deleteModal.idIri,
      )}
      validText="SUPPRIMER"
      modalType="suppression"
    >
      <p>
        Confirmez-vous la suppression de l&apos;étude comparative pour la typologie
        <span>{` ${deleteModal.typologyName} `}</span> sur la ville de
        <span>{` ${deleteModal.cityName} `}</span>?
      </p>
      <p>La suppression sera définitive.</p>
    </ActionModal>
  );
};

export default ComparativeStudyDeleteModal;
